import { Device } from "api/types/device";
import LabeledField from "providers/labeledField";
import photo from "assets/svg/empty-photo.svg";

import PhotoButton from "widgets/controls/buttons/photo";
import { t } from "i18next";
import { formatDate } from "util/datelib";
import { DeviceConfiguration } from "models/devices/configuration";
import DeviceCard from "widgets/cards/device";
import { useState } from "react";
import CircleButton from "widgets/controls/buttons/circle-button";
import QrCodeButton from "widgets/controls/buttons/qrcode";
import { MdPerson3, MdVerified } from "react-icons/md";
import JobStatusDialog, { JOB_STATUS } from "widgets/dialogs/jobStatus";
import InstallerDetailsDialog from "widgets/dialogs/installerDetails";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import { userGetInstaller } from "api/user";
import { notifySimple } from "providers/toast";

interface GeneralProps {
  device?: Device;
  job?: string;
  status?: JOB_STATUS;
  config?: DeviceConfiguration;
}

const Installer: React.FC<GeneralProps> = ({ device, config, job, status }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen0, setIsOpen0] = useState(false);
  const dispatch = useDispatch();
  const [installer, setInstaller] = useState<any>({});

  const fetchInstaller = async () => {
    dispatch(setLoading(true));
    const { data, status, isLoading, error } = await userGetInstaller(
      device?.installerName
    );
    dispatch(setLoading(isLoading));

    if (!error && status && status === 200) {
      setInstaller(data);
      setIsOpen0(true);
    } else {
      notifySimple(t("notification.error"), "error");
    }

    setLoading(false);
  };

  return (
    <DeviceCard
      title={t("device.installer.details")}
      config={config}
      topRight={
        <div className="-mt-2 flex items-center">
          {job && (
            <CircleButton
              icon={MdVerified}
              size="md"
              onClick={() => {
                setIsOpen(true);
              }}
              extra="-mr-2"
              variant="ghost"
              iconColor={
                status === "completed" ? "text-green-500/80" : "text-red-500/90"
              }
              tooltip={t("tooltip.verify.installations")}
              tooltipPlacement="bottom"
            />
          )}
          <CircleButton
            icon={MdPerson3}
            size="md"
            onClick={() => {
              fetchInstaller();
            }}
            extra="-mr-2"
            variant="ghost"
            tooltip={t("tooltip.view.installer")}
            tooltipPlacement="bottom"
            color="white"
          />
          <QrCodeButton data={device?.snr} type="snr" />
        </div>
      }
    >
      <div className="grid grid-cols-1 gap-1 md:gap-2">
        <LabeledField
          label={`${t("device.installer.name")}: `}
          id={"name"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {device?.installerName}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.date")}: `}
          id={"date"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {formatDate(device?.installDate, "default")}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.location")}: `}
          id={"location"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {device?.installLocation}
          </label>
        </LabeledField>
        <div className="flex items-center justify-evenly">
          {device?.photo1 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo1}
              context={"photo1"}
            />
          )}
          {device?.photo2 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo2}
              context={"photo2"}
            />
          )}
          {device?.photo3 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo3}
              context={"photo3"}
            />
          )}
          {device?.correctivePhoto && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.correctivePhoto}
              color="secondary"
              context={"corrective"}
            />
          )}
        </div>
        {/* </LabeledField> */}
      </div>
      {isOpen && (
        <JobStatusDialog
          isOpen={isOpen}
          status={status}
          id={job}
          onClose={() => setIsOpen(false)}
          onSuccess={() => {}}
        />
      )}
      {isOpen0 && (
        <InstallerDetailsDialog
          isOpen={isOpen0}
          installer={installer}
          onClose={() => setIsOpen0(false)}
        />
      )}
    </DeviceCard>
  );
};

export default Installer;
